/** @jsxImportSource @emotion/react */
import React, { useCallback } from "react";
import { css } from "@emotion/react";
import { Receiver } from "../../../store/global/GlobalStore";
import { selectedCss, selectedToCss } from "../SwapAndSendStyle";
import { sliceAddress, SliceAddressTypes } from "../../../utils/swapAndSendUtils";
import { ReactComponent as GenericWalletIcon } from "../../../img/generic_wallet.svg";
import { Tooltip } from "components/general/Tooltip";

interface SelectedAddressProps {
  receiver: Receiver;
  isValidAddress: boolean;
  displayLocation: SelectedAddressDisplayLocations;
}

export enum SelectedAddressDisplayLocations {
  "ReviewOrder" = "ReviewOrder",
  "TradeEntry" = "TradeEntry",
}

export const SelectedAddress: React.FC<SelectedAddressProps> = ({
  receiver,
  isValidAddress,
  displayLocation,
}) => {
  const receiverIconCss =
    displayLocation === SelectedAddressDisplayLocations.TradeEntry
      ? css`
          width: 31px;
          height: 31px;
        `
      : css`
          width: 21px;
          height: 21px;
        `;

  const receiverToDisplay = () => {
    if (receiver) {
      if (isValidAddress) {
        return (
          <Tooltip title={receiver.address}>
            {sliceAddress(SliceAddressTypes.Short, receiver.address)}
          </Tooltip>
        );
      } else if (receiver.ensName) {
        return <Tooltip title={receiver.address}>{receiver.ensName}</Tooltip>;
      }
    }
  };

  const iconToDisplay = useCallback(() => {
    if (receiver.avatar) {
      return (
        <img
          className="rounded-circle me-2"
          css={receiverIconCss}
          src={receiver.avatar}
          alt={"ENS Avatar"}
        />
      );
    } else if (isValidAddress) {
      return <GenericWalletIcon css={receiverIconCss} className="me-2" />;
    }
  }, [receiver, isValidAddress, receiverIconCss]);

  if (!receiver) {
    return null;
  }

  return (
    <>
      <span css={selectedCss}>
        <span className="me-2" css={selectedToCss}>
          To
        </span>
        {iconToDisplay()}
        {receiverToDisplay()}
      </span>
    </>
  );
};
